export const homeTabs = [
  { label: 'All Properties', tab: 'properties', icon: 'home' },
  { label: 'Export Data', tab: 'export', icon: 'pricetag' },
  { label: 'Profile', tab: 'profile', icon: 'settings' },
  { label: 'Settings', tab: 'settings', icon: 'cog' },
];
